import { render } from "./SuccessfullyCompleted.vue?vue&type=template&id=cb1486c2"
import script from "./SuccessfullyCompleted.vue?vue&type=script&lang=ts"
export * from "./SuccessfullyCompleted.vue?vue&type=script&lang=ts"
script.render = render

export default script